/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InformationExtractionLanguageEnum } from './InformationExtractionLanguageEnum';
import {
  InformationExtractionLanguageEnumFromJSON,
  InformationExtractionLanguageEnumFromJSONTyped,
  InformationExtractionLanguageEnumToJSON,
} from './InformationExtractionLanguageEnum';
import type { Perturbation } from './Perturbation';
import { PerturbationFromJSON, PerturbationFromJSONTyped, PerturbationToJSON } from './Perturbation';
import type { TaskTypeEnum } from './TaskTypeEnum';
import { TaskTypeEnumFromJSON, TaskTypeEnumFromJSONTyped, TaskTypeEnumToJSON } from './TaskTypeEnum';

/**
 *
 * @export
 * @interface PerturbedDatasetPolymorphicPerturbedInformationExtractionDataset
 */
export interface PerturbedDatasetPolymorphicPerturbedInformationExtractionDataset {
  /**
   *
   * @type {TaskTypeEnum}
   * @memberof PerturbedDatasetPolymorphicPerturbedInformationExtractionDataset
   */
  taskType: TaskTypeEnum;
  /**
   *
   * @type {number}
   * @memberof PerturbedDatasetPolymorphicPerturbedInformationExtractionDataset
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof PerturbedDatasetPolymorphicPerturbedInformationExtractionDataset
   */
  datasetPath: string;
  /**
   *
   * @type {boolean}
   * @memberof PerturbedDatasetPolymorphicPerturbedInformationExtractionDataset
   */
  hasPredictions?: boolean;
  /**
   *
   * @type {number}
   * @memberof PerturbedDatasetPolymorphicPerturbedInformationExtractionDataset
   */
  originalDataset: number;
  /**
   *
   * @type {Perturbation}
   * @memberof PerturbedDatasetPolymorphicPerturbedInformationExtractionDataset
   */
  readonly perturbation: Perturbation;
  /**
   *
   * @type {Array<number>}
   * @memberof PerturbedDatasetPolymorphicPerturbedInformationExtractionDataset
   */
  documents?: Array<number>;
  /**
   *
   * @type {number}
   * @memberof PerturbedDatasetPolymorphicPerturbedInformationExtractionDataset
   */
  schema: number;
  /**
   *
   * @type {InformationExtractionLanguageEnum}
   * @memberof PerturbedDatasetPolymorphicPerturbedInformationExtractionDataset
   */
  language: InformationExtractionLanguageEnum;
}

/**
 * Check if a given object implements the PerturbedDatasetPolymorphicPerturbedInformationExtractionDataset interface.
 */
export function instanceOfPerturbedDatasetPolymorphicPerturbedInformationExtractionDataset(
  value: object,
): value is PerturbedDatasetPolymorphicPerturbedInformationExtractionDataset {
  if (!('taskType' in value) || value['taskType'] === undefined) return false;
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('datasetPath' in value) || value['datasetPath'] === undefined) return false;
  if (!('originalDataset' in value) || value['originalDataset'] === undefined) return false;
  if (!('perturbation' in value) || value['perturbation'] === undefined) return false;
  if (!('schema' in value) || value['schema'] === undefined) return false;
  if (!('language' in value) || value['language'] === undefined) return false;
  return true;
}

export function PerturbedDatasetPolymorphicPerturbedInformationExtractionDatasetFromJSON(
  json: any,
): PerturbedDatasetPolymorphicPerturbedInformationExtractionDataset {
  return PerturbedDatasetPolymorphicPerturbedInformationExtractionDatasetFromJSONTyped(json, false);
}

export function PerturbedDatasetPolymorphicPerturbedInformationExtractionDatasetFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PerturbedDatasetPolymorphicPerturbedInformationExtractionDataset {
  if (json == null) {
    return json;
  }
  return {
    taskType: TaskTypeEnumFromJSON(json['task_type']),
    id: json['id'],
    datasetPath: json['dataset_path'],
    hasPredictions: json['has_predictions'] == null ? undefined : json['has_predictions'],
    originalDataset: json['original_dataset'],
    perturbation: PerturbationFromJSON(json['perturbation']),
    documents: json['documents'] == null ? undefined : json['documents'],
    schema: json['schema'],
    language: InformationExtractionLanguageEnumFromJSON(json['language']),
  };
}

export function PerturbedDatasetPolymorphicPerturbedInformationExtractionDatasetToJSON(
  value?: Omit<PerturbedDatasetPolymorphicPerturbedInformationExtractionDataset, 'id' | 'perturbation'> | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    task_type: TaskTypeEnumToJSON(value['taskType']),
    dataset_path: value['datasetPath'],
    has_predictions: value['hasPredictions'],
    original_dataset: value['originalDataset'],
    documents: value['documents'],
    schema: value['schema'],
    language: InformationExtractionLanguageEnumToJSON(value['language']),
  };
}
